/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodWareDishIcon16Light = forwardRef('FoodWareDishIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 3.896a1.25 1.25 0 1 0-1 0v1.395a6.28 6.28 0 0 0-3.905 1.804A6.286 6.286 0 0 0 1.271 11.5a.48.48 0 0 0 .958 0c0-1.384.565-2.748 1.544-3.727A5.319 5.319 0 0 1 7.5 6.229c1.384 0 2.748.565 3.727 1.544a5.318 5.318 0 0 1 1.544 3.727.48.48 0 0 0 .958 0 6.286 6.286 0 0 0-1.824-4.405A6.28 6.28 0 0 0 8 5.291V3.896Z" }),
        React.createElement("path", { d: "M.5 13a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H.5Z" })));
});
